module.exports = __webpack_public_path__ + "static/media/number6.aa580bb4.mp3";